import React from "react";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button, InputAdornment, TextField } from "@mui/material";
import { useParams } from "react-router-dom";


export default function Wallet() {
  
const {value}=useParams()


  
  return (
    <>
      <div className="px-3 pt-28">
        <p className="py-5  flex justify-between text-xl font-bold">
          Add Money <HelpOutlineOutlinedIcon />
        </p>
        <div className="flex ">
          <div className="flex-col">
            <img
              src="https://img.freepik.com/premium-vector/e-wallet-logo-design-vector-design-template_487414-3821.jpg"
              alt=""
              className="h-28 -mt-5"
            />
          </div>

          <div className="flex-col py-2">
            <p className="font-bold">Your Balance ₹ 0</p>
            <p>You can add upto ₹ 50,000</p>
          </div>
          <ChevronRightIcon className="mt-3" />
        </div>
        <p className="border py-3 rounded-lg">
          Get 10% cashback upto ₹500 using Federal Bank Debits Cards, Minimum
          Transaction of ₹2500, Once per user
        </p>
        <p className="font-bold py-5 text-left"> Please Enter An Amount</p>
        <TextField
          id="outlined-basic"
          InputProps={{
            startAdornment: <InputAdornment position="start"></InputAdornment>,
          }}
          placeholder="₹ 50,000"
          variant="outlined"
          className="rounded-lg  w-full !py-3 "
        />
        <div className="flex gap-3 justify-center py-3">
          <Button variant="contained" className="!bg-blue-200 !text-black">
            ₹ 50
          </Button>
          <Button variant="contained" className="!bg-blue-200 !text-black">
            ₹ 2,00
          </Button>
          <Button variant="contained" className="!bg-blue-200 !text-black">
            ₹ 5,00
          </Button>
          <Button variant="contained" className="!bg-blue-200 !text-black">
            ₹ 10,00
          </Button>
        </div>
        <div className="py-4">
          <Button variant="contained" className="!bg-blue-500 !w-full !py-3">
            Proceed to Add Money
          </Button>
          <div className="bg-white py-5">
            <p className="text-left font-bold">Apply Promo Code</p>
          </div>
          <div className="flex justify-center gap-5">
            <div className="flex flex-col">
              <TextField
                id="outlined-basic"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start"></InputAdornment>
                  ),
                }}
                placeholder="Enter Promo Code"
                variant="outlined"
                className="rounded-lg  !py-3 "
              />
            </div>
            <div className="flex flex-col">
              <Button variant="contained" className="!bg-blue-500 !mt-3 !py-3">
                Apply
              </Button>
            </div>
          </div>
        </div>
        <img
          src="	https://cdn.shopify.com/s/files/1/0686/4286/5468/products/RedBeans.jpg?v=1671066421"
          alt=""
          className="object-cover px-4 py-3 rounded-[25px] w-[100%] h-[220px]"
        />
        <p className="font-bold py-5 text-left">Please Note</p>
        <p className="text-left"></p>You can use Milkbasket money only for
        purchasing on milkbasket
      </div>
    </>
  );
}
